var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImprimir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 5.55556H3.3C1.474 5.55556 0 7.04445 0 8.88889V15.5556H4.4V20H17.6V15.5556H22V8.88889C22 7.04445 20.526 5.55556 18.7 5.55556ZM15.4 17.7778H6.6V12.2222H15.4V17.7778ZM18.7 10C18.095 10 17.6 9.5 17.6 8.88889C17.6 8.27778 18.095 7.77778 18.7 7.77778C19.305 7.77778 19.8 8.27778 19.8 8.88889C19.8 9.5 19.305 10 18.7 10ZM17.6 0H4.4V4.44444H17.6V0Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprimir);
export default __webpack_public_path__ + "static/media/Imprimir.939b929c600c770d0c59a154c6706238.svg";
export { ForwardRef as ReactComponent };